import Vue from 'vue';
import VueIziToast from 'vue-izitoast';
import 'izitoast/dist/css/iziToast.min.css';

Vue.prototype.$confirm = function (title, message, okBtnText, notOkBtntext, moreOptions) {
    return new Promise((resolve, reject) => {
        this.$toast.question(message, title, {
            position: "center",
            color: "white",
            iconColor: "yellow",
            icon: 'ico-warning',
            buttons: [
                [
                    `<button>${okBtnText}</button>`,
                    function (instance, toast) {
                        instance.hide({}, toast);
                        resolve(true)
                    },
                    true
                ],
                [
                    `<button class="not-ok-btn">${notOkBtntext}</button>`,
                    function (instance, toast) {
                        instance.hide({}, toast);
                        resolve(false)
                    }
                ]
            ],
            overlay: true,
            close: false,
            animateInside: false,
            drag: false,
            timeout: false,
            ...(moreOptions || {})
        });
    })
};
Vue.use(VueIziToast);
